import { DateInputValue } from "basis";
import { add, isAfter, isBefore, isSameDay, isValid, parseISO } from "date-fns";

export const validatePaymentStartDate = (value: DateInputValue) => {
  const { day, month, year } = value;
  const val = parseISO(
    `${year.padStart(4, "0")}-${month.padStart(2, "0")}-${day.padStart(
      2,
      "0",
    )}`,
  );

  if (!isValid(val)) {
    return "Please enter a valid date (DD/MM/YYYY).";
  }
  const currentDate = new Date();
  const latestStartDate = add(currentDate, { days: 30 });

  if (isSameDay(val, currentDate)) {
    return null;
  }

  if (!isAfter(val, currentDate)) {
    return "Your payment start date can not be in the past.";
  }

  if (!isBefore(val, latestStartDate)) {
    return "Your payment start date must be within 30 days from today.";
  }

  return null;
};
